import React from "react";
import { Button, Modal } from "react-bootstrap";

const SendPaymentLinkModal = ({ payModal, handleClose, sendPayLink }) => {
  return (
    <Modal show={payModal} onHide={() => handleClose()} backdrop={"static"}>
      <Modal.Header>
        <Modal.Title>Confirm</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure want to send the payment Link to patient?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={sendPayLink}>
          yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendPaymentLinkModal;
